import { useEffect, useState } from 'react';
import { FiRefreshCw, FiX } from 'react-icons/fi';
import {
  PWA_UPDATE_EVENT,
  applyPendingPwaUpdate,
  getPendingPwaUpdate
} from '../utils/pwaServiceWorker';

/** Updates are only applied after an explicit user action; never reload while editing. */
export const PwaUpdateNotice = () => {
  const [available, setAvailable] = useState(Boolean(getPendingPwaUpdate()));
  const [deferred, setDeferred] = useState(false);

  useEffect(() => {
    const onUpdate = () => {
      setAvailable(Boolean(getPendingPwaUpdate()));
      setDeferred(false);
    };
    window.addEventListener(PWA_UPDATE_EVENT, onUpdate);
    onUpdate();
    return () => window.removeEventListener(PWA_UPDATE_EVENT, onUpdate);
  }, []);

  if (!available || deferred) return null;

  return (
    <aside
      aria-label="InvoiceFlow update available"
      className="fixed bottom-[calc(6rem+env(safe-area-inset-bottom))] left-3 right-3 z-[10000] mx-auto max-w-md rounded-2xl border border-teal-200 bg-white p-3 shadow-xl xl:bottom-5 xl:left-auto xl:right-5"
    >
      <div className="flex items-start gap-3">
        <FiRefreshCw className="mt-1 h-5 w-5 shrink-0 text-teal-700" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-slate-900">InvoiceFlow update ready</p>
          <p className="mt-1 text-xs leading-5 text-slate-600">
            Finish saving any open invoice before reloading to the latest version.
          </p>
        </div>
        <button type="button" onClick={() => setDeferred(true)} className="min-h-11 min-w-11 rounded-lg text-slate-500 hover:bg-slate-50" aria-label="Update later">
          <FiX className="mx-auto h-5 w-5" />
        </button>
      </div>
      <div className="mt-2 flex justify-end gap-2">
        <button type="button" onClick={() => setDeferred(true)} className="min-h-11 rounded-lg px-4 text-sm font-semibold text-slate-600 hover:bg-slate-50">Later</button>
        <button type="button" onClick={applyPendingPwaUpdate} className="min-h-11 rounded-lg bg-teal-700 px-4 text-sm font-bold text-white hover:bg-teal-800">Reload now</button>
      </div>
    </aside>
  );
};